import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import * as Yup from "yup";
import { useSiteContext } from "../../contexts/SiteProvider";
import { showAlertAutoClose } from "../../services/notifyService";
import { post } from "../../services/smartApiService";
import { SECTOR_URLS } from "../../api/ManageUrls";
import { SdsForm } from "soft_digi";
import { SdsFormElementProps } from "soft_digi/dist/sdforms/SdsFromInterFace";

const schema = Yup.object({
  name: Yup.string().required("Sector name is required"),
  description: Yup.string().nullable(),
});

interface SectorFormProps {
  loadTableData: () => void;
  data?: any;
}

const SectorForm: React.FC<SectorFormProps> = ({ loadTableData, data }) => {
  const {
    control,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm<any>({
    resolver: yupResolver(schema),
    defaultValues: data
  });

  const { closeModal } = useSiteContext();

  const onSubmit = (_data: any) => {
    const isUpdate = data && data.id;

    const request$ = isUpdate
      ? post(`${SECTOR_URLS.UPDATE}${data.id}`, _data)
      : post(SECTOR_URLS.INSERT, _data,);

    const subscription = request$.subscribe(
      () => {
        showAlertAutoClose(
          `Sector ${isUpdate ? "updated" : "saved"} successfully`,
          "success"
        );
        reset();
        closeModal();
        loadTableData();
      },
      (error) => {
        showAlertAutoClose(
          error?.error?.message || "Failed to save sector",
          "error"
        );
      }
    );

    return () => subscription.unsubscribe();
  };


  const sectorElements: SdsFormElementProps[] = [
    {
      type: "TEXT_BOX",
      width: 12,
      name: "name",
      element: {
        label: "Sector Name",
        placeHolder: "Enter sector name",
        isRequired: true,
        inputType: "BORDER_LABEL",
      },
    },   {
      type: "TEXT_BOX",
      width: 12,
      name: "code",
      element: {
        label: "Code",
        placeHolder: "Enter Code",
        isRequired: true,
        inputType: "BORDER_LABEL",
      },
    },
    {
      type: "TEXTAREA",
      width: 12,
      name: "description",
      element: {
        label: "Description",
        placeHolder: "Enter description",
        rows: 3,
        inputType: "BORDER_LABEL",
      },
    },
    {
      type: "BUTTON",
      width: 6,
      name: "cancel",
      class_name: "",
      element: {
        label: "Cancel",
        classList: ["button"],
        onClick: () => closeModal(),
      },
    },
    {
      type: "BUTTON",
      width: 6,
      name: "submit",
      class_name: "has-text-right",
      element: {
        label: data ? "Update" : "Save",
        classList: ["button", "is-primary"],
        onClick: handleSubmit(onSubmit),
      },
    },
  ];

  return (
    <div className="">
      <SdsForm
        elements={sectorElements}
        control={control}
        errors={errors}
      />
    </div>
  );
};

export default SectorForm;
